import { useCallback, useContext, useEffect, useState } from "react";

import { useTheme } from "styled-components";

import { nonSelectedItemValue, Select, SelectDataType } from "@sso/components/Form";
import { TableContext } from "@sso/context/tableContext";
import { useMediaQuery } from "@sso/hooks/useMediaQuery";
import { useAppDispatch } from "@sso/hooks/useRedux";
import { SearchParameterKeys, SingleValueSearchColumn } from "@sso/types";

interface TableSearchSelectProps {
  items?: SelectDataType[];
  column: string;
  searchType: SearchParameterKeys;
  name: string;
}

export const TableSearchSelect = ({ column, items, name, searchType }: TableSearchSelectProps) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const { search } = useContext(TableContext);
  const [selectValue, setSelectValue] = useState(nonSelectedItemValue);
  const isMatchedDownSM = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  const searchField = search && (search.object[column] as SingleValueSearchColumn);
  const findItem = useCallback((value: string | number) => items?.find(item => item.value === value), [items]);

  useEffect(() => {
    if (!searchField || !searchField.value || !items) {
      setSelectValue(nonSelectedItemValue);
      return;
    }
    const selectedItem = findItem(searchField.value);
    setSelectValue(selectedItem && searchField.column === column ? selectedItem : nonSelectedItemValue);
  }, [column, findItem, items, search, searchField]);

  const handleSetSearch = (data: SelectDataType) => {
    if (!search) {
      return;
    }
    const value = String(data.value);
    if (!value) {
      return dispatch(search.onClear(column));
    }
    const title = `${name}: ${data.label}`;
    dispatch(search.onChange({ column, value: value, title, parameter: searchType }));
  };

  return (
    <Select
      width={isMatchedDownSM ? "100%" : "60%"}
      margin="0"
      maxWidth="450px"
      items={items || []}
      fieldProps={{ padding: "0.4rem" }}
      onChange={handleSetSearch}
      value={selectValue}
    />
  );
};
